import { Collection } from '@nozbe/watermelondb';

import {
    OnboardingModel,
    OnboardingPayload,
} from '../../../../types/RsvpOnboarding';
import { DBWriterLoggerFunction } from '../../../../types/logger';

export const prepareCreateOnboarding = ({
    payload,
    collection,
}: {
    payload: OnboardingPayload;
    collection: Collection<OnboardingModel>;
}) =>
    collection.prepareCreate((onboarding) => {
        onboarding.isAppointmentOnboarded =
            payload.isAppointmentOnboarded ?? false;
        onboarding.isInvitationOnboarded =
            payload.isInvitationOnboarded ?? false;
        onboarding.isBannerOnboarded = payload.isBannerOnboarded ?? false;
        onboarding.isDeclinedAppointmentsOnboarded =
            payload.isDeclinedAppointmentsOnboarded ?? false;
        onboarding.areBusinessDetailsOnboarded =
            payload.areBusinessDetailsOnboarded ?? false;
        onboarding.areEntriesOnboarded = payload.areEntriesOnboarded ?? false;
        onboarding.areInvoicesOnboarded = payload.areInvoicesOnboarded ?? false;
        onboarding.areProceduresOnboarded =
            payload.areProceduresOnboarded ?? false;
        onboarding.userId = payload.userId;
        onboarding.dashboardGettingStartedSectionDismissed =
            payload.dashboardGettingStartedSectionDismissed ?? false;
    });

export const logAddOnboardingAction = ({
    onboarding,
    logDBAction,
    tableName,
}: {
    onboarding: OnboardingModel;
    logDBAction: DBWriterLoggerFunction;
    tableName: string;
}) => {
    logDBAction({
        message: 'Create RSVP onboarding',
        modelName: tableName,
        payload: onboarding,
    });
};
